/* eslint-disable camelcase,no-undef */
import React, { Component, Suspense } from 'react';
import { DropdownItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { toast } from 'react-toastify';
import {
  Layout, Container, RequestContainer, RequestText, RequestCardWrapper, RequestCard, MainSectionV2,
  HeaderWrapperV2, TopCard, IconsContainerV2, ViewContainerV2, FilterIcon, StyledInputV2, SearchFilter,
  SearchIcon, CustomDropDownV2, SearchFilterWrapper, BuddyTabContainer, BuddyTab, AddEmployeeButton, CustomDropDownWellness, UpdateLocationButton
} from './styles';
import { Backdrop } from './ManageBuddies/styles';
import { UserButton } from '../EngagementSection/styles';
import PeopleListView from '../PeopleListViewV2/communityList';
import PeopleGridView from '../PeopleGridViewV2/communityGrid';
import Waiting from '../Waiting';
import NewEmployeePopup from '../NewEmployeePopupV2';
import CSVMaker from '../CSVMaker';
import {
  RemoveCSVData, FetchEmployeeCount, DeleteEmployeeAPI, FetchSetRemoveAPI, PostAddEmployee,
  fetchSearchPeople, getListOfEmployees, getSortedEmployees, uploadBiometricForm, viewPhysicianFormAPI, getUserRoles, getCompanyDetails,
  getFriendRequests, acceptOrRejectFriendRequest, getWellnessInterests, getCompanyLocation, sendFriendRequest
} from '../../redux/actions';
import { getSentRequestList,unFriendUser } from '../../redux/actions/socialActions';
import ReactPDF from '../../components/ReactPDF';
import { getPermissionStatus } from '../../utils/methods';
const AddRolesPopup = React.lazy(() => import('../AddRolesPopup'));
const EditUserDetailsPopup = React.lazy(() => import('./EditUserDetailsPopup'));
const RemoveBuddyPopup = React.lazy(() => import('./ManageBuddies/removeBuddyPopup'));
import { withTranslation } from 'react-i18next';
import { ImageUrl } from "../../utils/constants";
import { editDepartmentApi, editLocationApi } from '../../redux/actions/peopleHomeActions';
const AddLocationPopup = React.lazy(() => import('../NewEmployeePopupV2/locationPopup'));
const AddDepartmentPopup = React.lazy(() => import('../NewEmployeePopupV2/departmentPopup'));
import LazyImage from '../common/LazyImage/LazyImage';
import SkeletonLoder from '../common/skeletonLoder';
import { ConnectedFriend, SuggestedFriend } from '../../redux/constants/apiConstants';
import { fetchApi } from '../../utils/methods';
import { GridViewIcon, GridViewIconInActive, ListViewIcon, ListViewIconActive, NextSolidIcon, PriviousSolidIcon } from '../../utils/icons';

const WAIT_INTERVAL = 1500;
const ENTER_KEY = 13;

class PeopleHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: null,
      department: null,
      departmentId: null,
      engagement: '',
      alphabetical: null,
      alphabeticalId: '',
      search: '',
      showPopUp: false,
      showGrid: props.showView,
      companyId: props.companyInfo['id'],
      engagementSort: false,
      showSort: false,
      pageNo: 1,
      loading: false,
      minLimit: 1,
      maxLimit: '',
      total: '',
      countingValues: '',
      locationDropDown: null,
      locationDropDownId: '',
      loader: false,
      showPDFModal: false,
      buttonText: '',
      pdfBase64: '',
      uploadUid: null,
      showDeleteUserPopUp: false,
      selectUserDropDown: 'All',
      selectUserDropDownId: 0,
      showRolesPopup: false,
      showUserPopUp: false,
      wellnessInterest: null,
      wellnessInterestId: '',
      userId: null,
      initiativeId: null,
      initiativeName: null,
      wellnessSearch: false,
      peoplePage: null,
      peoplePageId: '',
      showLocation: false,
      showDepartment: false,
      participantLocation: false,
      participantDepartment: false,
      activeButton: false,
      selectedParticipant: [],
      showNote: false,
      NoteText: "Location",
      showTeams: false,
      connectionsTotal: 0,
      redirectToTop: false,
      activeTab: 'connections',
      userConnections: [],
      userSuggestions: [],
      hasMoreSuggestions: true,
      suggestionsTotal: 0,
      showRemoveBuddy: false,
      showRemoveButton: false,
      removeButtonId: null,
      removeBuddyName: null,
      removeBuddyId: null,
      popupType: "buddies",
      selectedWellnessInterests: [],
      selectedDepartments: [],
      selectedLocations: [],
      processingRequests: new Set()
    };
    this.timer = null;
  }

  componentDidMount() {
    this.props.fetchListOfEmployees();
    const { getCompanyDetails, fetchFriendRequests, getWellnessInterests, searchAmigo, getSentRequestList } = this.props;

    if (searchAmigo) {
      this.fetchUserConnections();
      fetchFriendRequests();
      getSentRequestList && getSentRequestList();
    } else {
      this.fetchEmployee();
      getCompanyDetails(this.state.companyId);
    }

    getWellnessInterests();
    getCompanyLocation(this.state.companyId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.redirectToTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ redirectToTop: false });
      }, 3000);
    }

    if (prevState.companyId !== this.state.companyId) {
      this.setState({
        search: '',
        pageNo: 1,
        engagementSort: false,
        showSort: false,
        department: null,
        departmentId: null,
        alphabetical: null,
        alphabeticalId: '',
        selectedWellnessInterests: [],
        selectedDepartments: [],
        selectedLocations: []
      }, () => {
        this.fetchEmployee();
      });
    }
  }


  handleWellnessInterestSelection = (interest) => {
    const { selectedWellnessInterests } = this.state;
    let updatedSelection;
    
    if (interest.id === "0") {
      updatedSelection = [];
    } else {
      const isSelected = selectedWellnessInterests.some((item) => item.id === interest.id);
      if (isSelected) {
        updatedSelection = selectedWellnessInterests.filter((item) => item.id !== interest.id);
      } else {
        updatedSelection = [...selectedWellnessInterests, interest];
      }
    }

    this.setState({
      selectedWellnessInterests: updatedSelection,
      pageNo: 1,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };

  handleDepartmentSelection = (department) => {
    const { selectedDepartments } = this.state;
    let updatedSelection;
    
    if (department.department === "All Department") {
      updatedSelection = [];
    } else {
      const isSelected = selectedDepartments.some((item) => item.id === department.id);
      if (isSelected) {
        updatedSelection = selectedDepartments.filter((item) => item.id !== department.id);
      } else {
        updatedSelection = [...selectedDepartments, department];
      }
    }

    this.setState({
      selectedDepartments: updatedSelection,
      pageNo: 1,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };

  handleLocationSelection = (location) => {
    const { selectedLocations } = this.state;
    let updatedSelection;
    
    if (location.state === "All Location" || location.city === "All Location") {
      updatedSelection = [];
    } else {
      const isSelected = selectedLocations.some((item) => item.id === location.id);
      if (isSelected) {
        updatedSelection = selectedLocations.filter((item) => item.id !== location.id);
      } else {
        updatedSelection = [...selectedLocations, location];
      }
    }

    this.setState({
      selectedLocations: updatedSelection,
      pageNo: 1,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };
  handleToggleAllWellness = () => {
    const { wellnessInterests } = this.props;
    const { selectedWellnessInterests } = this.state;
    
    const isAllSelected = wellnessInterests && selectedWellnessInterests.length === wellnessInterests.length;
    
    this.setState({
      selectedWellnessInterests: isAllSelected ? [] : wellnessInterests || [],
      pageNo: 1,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };

  handleToggleAllDepartments = () => {
    const { selectedDepartments } = this.state;
    const isAllSelected = this.props.departmentDetails && selectedDepartments.length === this.props.departmentDetails.length;
    
    this.setState({
      selectedDepartments: isAllSelected ? [] : this.props.departmentDetails || [],
      pageNo: 1,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };

  handleToggleAllLocations = () => {
    const { selectedLocations } = this.state;
    const isAllSelected = this.props.locationDetails && selectedLocations.length === this.props.locationDetails.length;
    
    this.setState({
      selectedLocations: isAllSelected ? [] : this.props.locationDetails || [],
      pageNo: 1,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };
  onChange = (e) => {
    e.preventDefault();
    const value = e.target.value;

    this.setState({
      search: value,
      pageNo: 1,
      engagementSort: false,
      showSort: false,
      hasMoreSuggestions: true,
      userSuggestions: []
    }, () => {
      if (this.state.activeTab === 'connections') {
        this.onSearchFunction();
      } else if (this.state.activeTab === 'suggestions') {
        this.onSearchFunction();
      }
    });
  };

  onSearchFunction = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    }, WAIT_INTERVAL);
  };

  handleKeyDown = (evt) => {
    if (evt.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      if (this.state.activeTab === 'connections') {
        this.fetchUserConnections();
      } else if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    }
  };


  getSelectedItemsText = (selectedItems, type) => {
    if (selectedItems.length === 0) {
      return type === 'wellness' ? 'Wellness Interest' : 
        type === 'department' ? 'Department' : 'Location';
    }
    if (selectedItems.length === 1) {
      return type === 'wellness' ? selectedItems[0].name :
        type === 'department' ? selectedItems[0].department :
          selectedItems[0].state && selectedItems[0].city ? 
            `${selectedItems[0].state}, ${selectedItems[0].city}` :
            selectedItems[0].state || selectedItems[0].city;
    }
    return `${selectedItems.length} selected`;
  };

  openCloseRemoveBuddyPopup = (name, id) => {
    this.setState({
      showRemoveBuddy: !this.state.showRemoveBuddy,
      removeBuddyName: name,
      removeBuddyId: id,
      showRemoveButton: false
    });
  };

  closeRemoveBuddyPopup = () => {
    this.setState({
      showRemoveBuddy: false,
      removeBuddyName: null,
      removeBuddyId: null
    });
  };

  showRemoveButtonHandler = (id) => {
    this.setState({
      showRemoveButton: !this.state.showRemoveButton,
      removeButtonId: id
    });
  };

  hideRemoveButton = () => {
    this.setState({
      showRemoveButton: false,
      removeButtonId: null
    });
  };

  switchTab = (tab) => {
    this.setState({
      activeTab: tab,
      search: '',
      department: null,
      departmentId: null,
      locationDropDown: null,
      locationDropDownId: null,
      wellnessInterest: null,
      wellnessInterestId: '',
      selectedWellnessInterests: [],
      selectedDepartments: [],
      selectedLocations: [],
      pageNo: 1,
      hasMoreSuggestions: true,
      showRemoveButton: false,
      removeButtonId: null
    }, () => {
      if (tab === 'connections') {
        this.fetchUserConnections();
        this.props.fetchFriendRequests(); // Add this line
      } else {
        this.fetchUserSuggestions();
        this.props.getSentRequestList && this.props.getSentRequestList();
      }
    });
  };

  cancelFriendRequest = (request) => {
    const requestId = request.request_id || request.id || request.friend_request_id;
    this.props.acceptOrRejectFriendRequest({ request_id: requestId, status: 'Rejected' });
  };

  transformConnectionsData = (connections) => {
    if (!Array.isArray(connections)) return [];
    
    return connections.map((item) => {
      const friend = item.friend || item.friend_details || item.user || item;
      const uid = friend.user_id || friend.uid || friend.id || item.friend_id;
      const name = friend.fullname || friend.full_name || friend.name || (friend.first_name ? `${friend.first_name} ${friend.last_name || ''}` : '') || 'Unknown';
      const profile_image = friend.profile_image || friend.avatar || item.profile_image || '';

      let locationStr = '';
      if (friend.city && friend.state) locationStr = `${friend.city}, ${friend.state}`;
      else if (friend.city) locationStr = friend.city;
      else if (friend.state) locationStr = friend.state;
      else locationStr = friend.location || '';

      const rawInterests = friend.interests || friend.wellness_interests || friend.wellness_interest || item.interests || [];
      const wellness_interest = Array.isArray(rawInterests) ? rawInterests.map((interest) => ({
        interest_id: interest.interest_id || interest.id,
        interest_name: interest.interest_name || interest.name,
        interest_icon: interest.interest_icon || interest.icon,
        interest_color_icon: interest.interest_color_icon || interest.interest_icon || interest.icon
      })) : [];

      return {
        uid: uid,
        id: uid,
        connection_id: item.id || item.connection_id,
        friend_id: item.friend_id || uid,
        fullname: name,
        full_name: name,
        name: name,
        profile_image: profile_image,
        state: friend.state || '',
        city: friend.city || '',
        location: locationStr,
        department: friend.department || item.department || '',
        is_champion: friend.is_champion || 0,
        wellness_interest: wellness_interest,
        interests: wellness_interest,
        mutual_friends: item.mutual_friends || friend.mutual_friends || item.mutual_friends_count || 0,
        mutual_friends_details: item.mutual_friends_details || [],
        connection_date: item.connection_date || null,
        email: friend.email || '',
        phone: friend.phone || '',
        role: friend.role || 'Employee',
        user_type: friend.user_type || 0,
        engagement_score: friend.engagement_score || 0,
        points: friend.points || 0,
        friend: this.state.activeTab === 'connections' ? -1 : 0
      };
    });
  };

  fetchUserConnections = async () => {
    try {
      this.setState({ loading: true });
      const { search, selectedDepartments, selectedLocations, selectedWellnessInterests, pageNo } = this.state;
      
      const payload = {
        page_no: pageNo, // Use pageNo instead of hardcoded 1
        limit: 24,
        name: search && search.trim() !== '' ? search.trim() : "",
        interest_ids: selectedWellnessInterests.length > 0 ? selectedWellnessInterests.map((interest) => interest.id) : [],
        department_ids: selectedDepartments.length > 0 ? selectedDepartments.map((dept) => dept.id) : [],
        city_state_ids: selectedLocations.length > 0 ? selectedLocations.map((loc) => loc.id) : []
      };

      const response = await fetchApi(ConnectedFriend, 'POST', payload);

      if (response && response.status === 'success' && response.data) {
        let allConnections = [];
        let totalConnections = 0;
        
        if (response.data.connections && Array.isArray(response.data.connections)) {
          allConnections = response.data.connections;
          totalConnections = response.data.total || allConnections.length;
        } else if (Array.isArray(response.data)) {
          allConnections = response.data;
          totalConnections = response.total || allConnections.length;
        }

        const transformedConnections = this.transformConnectionsData(allConnections);
        this.setState({
          userConnections: transformedConnections,
          connectionsTotal: totalConnections,
          loading: false
        });
      } else {
        this.setState({
          userConnections: [],
          connectionsTotal: 0,
          loading: false
        });
      }
    } catch (error) {
      console.error('Error fetching connections:', error);
      this.setState({
        userConnections: [],
        connectionsTotal: 0,
        loading: false
      });
    }
  };


  fetchUserSuggestions = async () => {
    try {
      this.setState({ loading: true });
      const { search, selectedDepartments, selectedLocations, selectedWellnessInterests, pageNo } = this.state;
      
      const payload = {
        page_no: pageNo,
        limit: 24,
        name: search && search.trim() !== '' ? search.trim() : "",
        interest_ids: selectedWellnessInterests.length > 0 ? selectedWellnessInterests.map((interest) => interest.id) : [],
        department_ids: selectedDepartments.length > 0 ? selectedDepartments.map((dept) => dept.id) : [],
        city_state_ids: selectedLocations.length > 0 ? selectedLocations.map((loc) => loc.id) : []
      };

      const response = await fetchApi(SuggestedFriend, 'POST', payload);

      if (response && response.status === 'success' && response.data) {
        let allSuggestions = [];
        let totalSuggestions = 0;
        
        if (response.data.suggestions && Array.isArray(response.data.suggestions)) {
          allSuggestions = response.data.suggestions;
          totalSuggestions = response.data.total || allSuggestions.length;
        } else if (Array.isArray(response.data)) {
          allSuggestions = response.data;
          totalSuggestions = response.total || allSuggestions.length;
        }

        const transformedSuggestions = this.transformConnectionsData(allSuggestions);
        
        this.setState({
          userSuggestions: transformedSuggestions, // Always reset
          suggestionsTotal: totalSuggestions,
          hasMoreSuggestions: allSuggestions.length === 24 && (pageNo * 24) < totalSuggestions, // Fix limit check
          loading: false
        });
      } else {
        this.setState({
          userSuggestions: [],
          hasMoreSuggestions: false,
          loading: false
        });
      }
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      this.setState({
        userSuggestions: [],
        hasMoreSuggestions: false,
        loading: false
      });
    }
  };




  removeConnection = (connectionId) => {
    try {
      this.setState((prevState) => ({
        userConnections: Array.isArray(prevState.userConnections) 
          ? prevState.userConnections.filter((conn) => 
            conn && String(conn.uid) !== String(connectionId) && 
            String(conn.friend_id) !== String(connectionId) &&
            String(conn.id) !== String(connectionId)
          )
          : []
      }));
      
      this.closeRemoveBuddyPopup();
      
      if (this.props.unFriendUser) {
        this.props.unFriendUser(connectionId, false);
      }

      // Refresh connections after removing
      setTimeout(() => {
        this.fetchUserConnections();
        toast.success(this.props.t("Buddy removed successfully"));
      }, 1000);
      
    } catch (error) {
      console.error('Error removing connection:', error);
      toast.error(this.props.t("Failed to remove buddy"));
    }
  };



  sendFriendRequestToSuggestion = async (suggestionId) => {
    try {
      this.props.sendFriendRequest(suggestionId, {});
      
      this.setState((prevState) => ({
        userSuggestions: Array.isArray(prevState.userSuggestions) 
          ? prevState.userSuggestions.filter((sugg) => sugg.uid !== suggestionId)
          : []
      }));
      
      // Increase timeout and ensure both APIs are called
      setTimeout(() => {
        this.props.getSentRequestList && this.props.getSentRequestList();
        this.fetchUserSuggestions();
      }, 1000); // Increased from 500ms to 1000ms

    } catch (error) {
      console.error('Error sending friend request:', error);
      toast.error(this.props.t("Failed to send friend request"));
    }
  };




  getUserData = () => {
    const { userProfile } = this.props;
    if (userProfile) return userProfile;

    try {
      const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData') || localStorage.getItem('user') || sessionStorage.getItem('user');
      if (userData) return JSON.parse(userData);

      const authToken = localStorage.getItem('AUTH_TOKEN');
      if (authToken) {
        const tokenData = JSON.parse(atob(authToken.split('.')[1]));
        return tokenData;
      }
    } catch (e) {
      console.error('Error parsing user data:', e);
    }

    return { uid: 1, id: 1, user_id: 1 };
  };

  applyConnectionsFiltersAndPagination = () => {
    const { userConnections, connectionsTotal} = this.state;
    const itemsPerPage = 24;
    const totalPages = Math.ceil(connectionsTotal / itemsPerPage);
    
    return {
      data: Array.isArray(userConnections) ? userConnections : [],
      totalCount: connectionsTotal,
      totalPages: totalPages
    };
  };


  applySuggestionsFiltersAndPagination = () => {
    const { userSuggestions, pageNo } = this.state;
    
    const itemsPerPage = 24; // Change from 16 to 24 to match API limit
    const totalPages = Math.ceil(this.state.suggestionsTotal / itemsPerPage);
    
    return {
      data: Array.isArray(userSuggestions) ? userSuggestions : [],
      totalCount: this.state.suggestionsTotal,
      totalPages: totalPages,
      currentPage: pageNo,
      hasMore: this.state.hasMoreSuggestions
    };
  };


  onEnterMouse = (uid, id, name) => {
    this.setState({
      userId: uid,
      initiativeId: id,
      initiativeName: name
    });
  };

  onLeaveMouse = () => {
    this.setState({
      userId: null,
      initiativeId: null
    });
  };

  UNSAFE_componentWillReceiveProps(prevProps) {
    const { paginationCount } = prevProps;
    if (paginationCount && (this.state.countingValues !== paginationCount)) {
      this.setState({
        total: Math.ceil(paginationCount / 16),
        countingValues: paginationCount
      }, () => {
        if (this.state.total < 6) {
          this.setState({ maxLimit: this.state.total });
        } else {
          this.setState({ maxLimit: 6 });
        }
      });
    }
  }

  nextPageDetail = (e) => {
    e.preventDefault();
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if (bottom) {
      this.setState({
        pageNo: this.state.pageNo + 1
      }, () => {
        if (this.state.activeTab === 'suggestions') {
          this.fetchUserSuggestions();
        }
      });
    }
  };


  updateDropdown = (title, id, titleKey, idKey) => {
    this.setState({
      [titleKey]: title,
      [idKey]: id,
      pageNo: 1,
      engagementSort: false,
      showSort: false,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };

  updateWellnessDropdown = (title, id, titleKey, idKey) => {
    if (title !== "All") {
      this.setState({ wellnessSearch: true });
    } else {
      this.setState({ wellnessSearch: false });
    }
    this.setState({
      [titleKey]: title,
      [idKey]: id,
      pageNo: 1,
      engagementSort: false,
      showSort: false,
      hasMoreSuggestions: true
    }, () => {
      if (this.state.activeTab === 'suggestions') {
        this.fetchUserSuggestions();
      } else {
        this.fetchEmployee();
      }
    });
  };

  fetchEmployee = () => {
    this.setState({ uploadUid: null });
    let obj = {};
    const { pageNo, companyId, search, selectedWellnessInterests, selectedDepartments, selectedLocations, peoplePageId } = this.state;

    if (pageNo === 1) {
      this.setState({ loading: true });
    } else {
      this.changeLoading();
    }

    const { fetchSearchPeople } = this.props;
    if (peoplePageId !== '') {
      if (peoplePageId !== 'all') {
        obj['point_sort'] = peoplePageId;
      }
    }
    obj['company_id'] = companyId;
    obj['name'] = search && search.trim();
    obj['page_no'] = pageNo;
    obj['limit'] = 16;
    
    if (selectedWellnessInterests.length > 0) {
      obj['interest_ids'] = selectedWellnessInterests.map((interest) => interest.id);
    }

    if (selectedDepartments.length > 0) {
      obj['department_ids'] = selectedDepartments.map((dept) => dept.id);
    }

    if (selectedLocations.length > 0) {
      obj['city_state_ids'] = selectedLocations.map((loc) => loc.id);
    }

    fetchSearchPeople(obj, this.changeLoading);
    this.setState({
      selectedEmp: null,
      selectedEmployee: null
    });
  };

  fetchEmployeePost = (uid) => {
    if (this.state.activeTab === 'suggestions') {
      this.sendFriendRequestToSuggestion(uid);
      return;
    }

    this.setState({ uploadUid: null });
    let obj = {};
    const { pageNo, companyId, search, selectedDepartments, selectedLocations } = this.state;
    const { fetchEmployeeCount, sendFriendRequest } = this.props;
    obj['company_id'] = companyId;
    obj['name'] = search && search.trim();
    obj['page_no'] = pageNo;
    obj['limit'] = 16;

    if (selectedDepartments.length > 0) {
      obj['department_ids'] = selectedDepartments.map((dept) => dept.id);
    }

    if (selectedLocations.length > 0) {
      obj['city_state_ids'] = selectedLocations.map((loc) => loc.id);
    }

    fetchEmployeeCount(obj, false);
    sendFriendRequest(uid, obj);
  };

  deleteUserAction = (uid) => {
    const { deleteEmployeeAPI } = this.props;
    let obj = {};
    obj['user_uid'] = uid;
    deleteEmployeeAPI(obj);
    this.setState({ selectedEmployee: null });
  };

  getCompany = (value) => {
    if (!this.state.loading) {
      const { companies, setCompany } = this.props;
      const id = companies.filter((company) => company.company_name === value)[0].id;
      this.setState({
        companyId: id,
        pageNo: 1,
        selectedEmployee: null,
        countingValues: '',
        minLimit: 1,
        maxLimit: '',
        departmentId: null,
        locationDropDownId: null,
        selectedWellnessInterests: [],
        selectedDepartments: [],
        selectedLocations: []
      });
      setCompany(id, value);
    }
  };

  changeOrder = () => {
    this.setState({
      engagementSort: !this.state.engagementSort,
      showSort: true,
      pageNo: 1,
      selectedEmployee: null,
      alphabetical: null,
    }, () => {
      this.fetchEmployee();
    });
  };

  setorRemoveAction = (uid, status) => {
    const { fetchSetRemoveAPI } = this.props;
    let obj = {};
    obj['uid'] = uid;
    obj['status'] = !status ? 1 : 0;
    obj['company_id'] = this.state.companyId;
    obj['role'] = 11;
    fetchSetRemoveAPI(obj);
  };

  addEmployeePopUp = () => {
    this.setState({ showPopUp: !this.state.showPopUp });
  };

  updateLocationPopUp = () => {
    this.setState({ showLocation: !this.state.showLocation });
  };

  addParticipantsLocation = () => {
    let participant = JSON.parse(localStorage.getItem("selectedEmployeeList"));
    this.setState({
      participantLocation: !this.state.participantLocation,
      selectedParticipant: participant,
      activeButton: !this.state.activeButton
    });
  };

  addParticipantsDepartment = () => {
    let participant = JSON.parse(localStorage.getItem("selectedEmployeeList"));
    this.setState({
      participantDepartment: !this.state.participantDepartment,
      selectedParticipant: participant
    });
  };

  updateDepartmentPopUp = () => {
    this.setState({ showDepartment: !this.state.showDepartment });
  };

  userModal = () => {
    this.setState((prevState) => ({
      showUserPopUp: !prevState.showUserPopUp
    }));
  };

  showEmployeeDetails = (id) => {
    if (!this.state.loading) {
      this.setState({ selectedEmployee: id });
    }
  };

  updatePoints = (title, id, titleKey, idKey) => {
    this.setState({
      [titleKey]: title,
      [idKey]: id,
    }, () => {
      this.fetchEmployee();
    });
  };

  onSelect = (value, state) => {
    this.setState({
      [state]: value
    }, () => {
      const { department, engagement, alphabetical, search } = this.state;
      this.sortEmployees(search, engagement, department, alphabetical);
    });
  };

  sortEmployees = (search, engagement, department, alphabetical) => {
    this.props.fetchSortedEmployees(search, engagement, department, alphabetical);
  };

  showView = (value) => {
    this.setState({ showGrid: value });
  };

  getMenuItems = () => {
    const { companies } = this.props;
    return companies && companies.map((company) => company.company_name);
  };

  getPaginationCircle = () => {
    let circleButton = [];
    for (let i = this.state.minLimit; i <= this.state.maxLimit; i++) {
      circleButton.push(
        <UserButton
          key={i}
          width="30px"
          height="34px"
          Align={1}
          marginLeft="5px"
          fontSize="14px"
          bgColor={i === this.state.pageNo ? "#DA6C74" : "#f8f8f8"}
          color={i === this.state.pageNo ? "#fff" : "#DA6C74"}
          capitalize={1}
          onClick={() => this.setPagination(i)}
        >
          {i}
        </UserButton>
      );
    }
    return circleButton;
  };

  getSuggestionsPaginationCircle = () => {
    const { pageNo } = this.state;
    const result = this.applySuggestionsFiltersAndPagination();
    const totalPages = result.totalPages;
    
    let circleButton = [];
    const maxButtons = 6;
    let startPage = Math.max(1, pageNo - Math.floor(maxButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxButtons - 1);
    
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(1, endPage - maxButtons + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      circleButton.push(
        <UserButton
          key={i}
          width="30px"
          height="34px"
          Align={1}
          marginLeft="5px"
          fontSize="14px"
          bgColor={i === pageNo ? "#DA6C74" : "#f8f8f8"}
          color={i === pageNo ? "#fff" : "#DA6C74"}
          capitalize={1}
          onClick={() => this.setSuggestionsPagination(i)}
        >
          {i}
        </UserButton>
      );
    }
    return circleButton;
  };

  setPagination = (activeIndex) => {
    this.setState({ redirectToTop: true });
    if (activeIndex !== this.state.pageNo) {
      this.setState({ pageNo: activeIndex }, () => {
        if (this.state.activeTab === 'connections') {
          return;
        } else if (this.state.activeTab === 'suggestions') {
          this.fetchUserSuggestions();
        } else {
          this.fetchEmployee();
        }
      });
    }
  };

  setSuggestionsPagination = (activeIndex) => {
    this.setState({ redirectToTop: true });
    if (activeIndex !== this.state.pageNo) {
      this.setState({ 
        pageNo: activeIndex,
        userSuggestions: []
      }, () => {
        this.fetchUserSuggestions();
      });
    }
  };

  changeLoader = (bool) => {
    this.setState({ loader: bool });
  };

  uploadPDFFile = (e, id) => {
    let file = e.target.files[0];
    if (file) {
      let fileArr = file.name.split('.');
      if (fileArr[fileArr.length - 1].toUpperCase() === 'PDF') {
        if ((file?.size / 1000000) <= 10) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => {
            this.setState({
              showPDFModal: true,
              pdfBase64: reader.result,
              buttonText: "Submit",
              uploadUid: id
            });
          };
        } else {
          toast.error('Please select PDF file less than 10MB');
          this.changeLoader(false);
          document.getElementById('biometric-user-admin-file').value = '';
        }
      } else {
        toast.error('Please select PDF file');
        this.changeLoader(false);
        document.getElementById('biometric-user-admin-file').value = '';
      }
    } else {
      this.changeLoader(false);
      document.getElementById('biometric-user-admin-file').value = '';
    }
  };

  removePDF = () => {
    this.setState({
      showPDFModal: false,
      pdfBase64: '',
      buttonText: "",
      uploadUid: null
    });
    document.getElementById('biometric-user-admin-file').value = '';
  };

  closePopup = () => {
    const { uploadUid, pdfBase64 } = this.state;
    if (pdfBase64.trim() !== '' && uploadUid) {
      this.changeLoader(true);
      this.props.uploadBiometricForm({ physician_form: pdfBase64 }, this.changeLoader, uploadUid, this.fetchEmployee);
      this.setState({ showPDFModal: false });
    }
  };

  showPDFData = (id) => {
    const { viewPhysicianFormAPI } = this.props;
    this.changeLoader(true);
    viewPhysicianFormAPI(id, this.changeLoader);
  };

  onToggleDeletePopup = () => {
    this.setState((prev) => ({ showDeleteUserPopUp: !prev.showDeleteUserPopUp }));
  };

  onToggleRolesPopup = (uid) => {
    this.setState((prev) => ({ showRolesPopup: !prev.showRolesPopup }), () => { this.state.showRolesPopup && this.props.getUserRoles(uid); });
  };

  changeLoading = () => {
    this.setState({ loading: false });
  };

  acceptOrRejectRequest = (id, status) => {
    // Prevent double clicks
    if (this.state.processingRequests.has(id)) {
      return;
    }

    // Add to processing set
    this.setState((prevState) => ({
      processingRequests: new Set([...prevState.processingRequests, id])
    }));

    const { acceptOrRejectFriendRequest, fetchFriendRequests } = this.props;
    
    if (status === 'Accepted') {
      const acceptedRequest = this.props.friendRequests.find((req) => req.id === id);
      if (acceptedRequest) {
        const newConnection = this.transformConnectionsData([acceptedRequest]);
        this.setState((prevState) => ({
          userConnections: [...(prevState.userConnections || []), ...newConnection]
        }));
      }
    }
    
    acceptOrRejectFriendRequest({ request_id: id, status: status });
    fetchFriendRequests();
    
    // Refresh connections after accepting
    if (status === 'Accepted') {
      setTimeout(() => {
        this.fetchUserConnections();
      }, 1000);
    }
    
    setTimeout(() => {
      this.setState((prevState) => ({
        processingRequests: new Set([...prevState.processingRequests].filter((reqId) => reqId !== id))
      }));
    }, 2000);
  };





  fallBack = (e) => {
    e.target.src = '/public/images/default.png';
  };

  showManage = () => {
    const { history } = this.props;
    history.push('/community/manage-buddies');
  };

  handleShowNote = (text) => {
    this.setState({
      showNote: !this.state.showNote,
      NoteText: text
    });
    this.fetchEmployee();
  };

  hideShowTeam = (status) => {
    const { history } = this.props;
    this.setState({ showTeams: status });
    if (status) {
      history.push('/company/people/team');
    }
  };

  hideShowInactiveUsers = (status) => {
    const { history } = this.props;
    this.setState({ showTeams: status });
    if (status) {
      history.push('/company/people/inactive-users');
    }
  };

  render() {
    const { employeeList, companyInfo, employeeData, downloadCSV, csvData,
      removeCSVData, paginationCount, searchAmigo, userRolesList, count, companyDetails, friendRequests, wellnessInterests, history, t, sendRequestsData } = this.props;
    const { selectedEmployee, showPopUp, loader, showPDFModal, pdfBase64, buttonText, showRolesPopup, showUserPopUp, showLocation, showDepartment, activeButton, activeTab,
      showRemoveBuddy, showRemoveButton, removeButtonId, removeBuddyName, removeBuddyId, popupType, selectedWellnessInterests, selectedDepartments, selectedLocations } = this.state;

    let displayData = [];
    let totalCount = 0;
    let totalPages = 0;

    if (searchAmigo && activeTab === 'connections') {
      const result = this.applyConnectionsFiltersAndPagination();
      displayData = result.data;
      totalCount = result.totalCount;
      totalPages = result.totalPages;
    } else if (searchAmigo && activeTab === 'suggestions') {
      const result = this.applySuggestionsFiltersAndPagination();
      displayData = result.data;
      totalCount = result.totalCount;
      totalPages = result.totalPages;
    } else {
      displayData = employeeData || [];
      totalCount = count || 0;
    }

    if (_.isUndefined(employeeList) || _.isNull(employeeList) || _.isUndefined(friendRequests) || _.isUndefined(wellnessInterests)) {
      return <Waiting />;
    }

    let selectedEmp = false;
    let selectedEmployeeDetail = false;
    if (displayData && displayData.length > 0) {
      selectedEmp = selectedEmployee ? selectedEmployee : displayData[0].uid;
      selectedEmployeeDetail = displayData.filter((employee) => employee.uid === selectedEmp);
    }

    let WellnessInterestAll = [{ name: 'All', id: "0" }];
    // let WellnessInterests = [];
    if (wellnessInterests && wellnessInterests.length > 0) {
      WellnessInterests = [...WellnessInterestAll, ...wellnessInterests];
    }

    let DepartmentAll = [{ department: 'All Department', id: "0" }];
    // let DepartmentList = [];
    if (this.props.departmentDetails && this.props.departmentDetails.length > 0) {
      DepartmentList = [...DepartmentAll, ...this.props.departmentDetails];
    }

    let LocationAll = [{ state: 'All Location', city: null, id: "0" }];
    // let LocationList = [];
    if (this.props.locationDetails && this.props.locationDetails.length > 0) {
      LocationList = [...LocationAll, ...this.props.locationDetails];
    }

    return (
      <Layout>
        {loader && <Waiting />}
        {showRemoveButton && <Backdrop onClick={this.hideRemoveButton} />}
        <Container>
          {searchAmigo && (
            <BuddyTabContainer show={true}>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', gap: '20px' }}>
                <BuddyTab
                  active={activeTab === 'connections'}
                  onClick={() => this.switchTab('connections')}
                  style={{ width: "auto", padding: "0 15px", cursor: 'pointer' }}
                >
                  {t("Connections")} 
                </BuddyTab>
                <BuddyTab
                  active={activeTab === 'suggestions'}
                  onClick={() => this.switchTab('suggestions')}
                  style={{ width: "auto", padding: "0 15px", cursor: 'pointer' }}
                >
                  {t("Suggestions")}
                </BuddyTab>
              </div>
              {/* {searchAmigo && <ManageButton width="125px" height="40px" onClick={() => this.showManage()}>{t("Suggestion")}</ManageButton>} */}
            </BuddyTabContainer>
          )}
          {sendRequestsData && sendRequestsData.length > 0 && searchAmigo && activeTab === 'suggestions' &&
            <RequestContainer background="white">
              <RequestText>
                {t("Pending Request")}
              </RequestText>
              <RequestCardWrapper style={{ flexWrap: 'wrap', height: 'auto', minHeight: '120px'}}>
                {sendRequestsData.map((request, index) =>
                  (<RequestCard key={index} style={{ minHeight: '120px', height: 'auto', marginBottom: '16px', background:'#FEFEFE', border:'1px solid #DCDCDC' }}>
                    <div className="profile">
                      <img onError={this.fallBack} src={`${ImageUrl}/${request.profile_image}`} alt={"Profile"} />
                    </div>
                    <div className="info">
                      <div className="name">{t(request.fullname)}</div>
                      <div className="wellness-icon">
                        {request.wellness_interest && request.wellness_interest.length > 0 && request.wellness_interest.map((wellness, idx) =>
                          (idx < 5 && <div key={idx} onMouseEnter={() => this.onEnterMouse(request.id, wellness.interest_id, wellness.interest_name)} onMouseLeave={() => this.onLeaveMouse()}>
                            <img src={`${ImageUrl}/${wellness.interest_icon}`} />
                          </div>
                          ))}
                      </div>
                    </div>
                    <div className="last-card">
                      <div className="cancel" style={{width:'auto', padding:'8px 16px'}} onClick={() => this.cancelFriendRequest(request)}>{t("Cancel Request")}</div>
                    </div>
                  </RequestCard>))
                }
              </RequestCardWrapper>
            </RequestContainer>
          }
          <HeaderWrapperV2>
            <TopCard>
              <div>
                <LazyImage div={'profile'} src={ImageUrl + "/images/PeoplePage/People_Group_Img.png"} alt="people_icon" />
                <div className="count">
                  {totalCount} {searchAmigo ? (activeTab === 'connections' ? t("Connections") : t("Suggestions")) : t("Employees")}
                </div>
              </div>
              <div>
                <ViewContainerV2>
                  {!searchAmigo && this.props.locationDetails && this.props.locationDetails.length > 0 &&
                    <UpdateLocationButton onClick={this.updateLocationPopUp}>
                      {t("Update Location")}
                    </UpdateLocationButton>}
                  {!searchAmigo && (getPermissionStatus("Add Employee", this.props.userPermissions)) &&
                    <AddEmployeeButton onClick={this.addEmployeePopUp}>
                      {t("Add New Employee")}
                    </AddEmployeeButton>
                  }
                  <IconsContainerV2>
                    {this.state.showGrid ? 
                      <div style={{cursor:'pointer'}} onClick={() => this.showView(false)}>{ListViewIcon()}</div> : 
                      <div style={{cursor:'pointer'}} onClick={() => this.showView(false)}>{ListViewIconActive()}</div>
                    }
                    {this.state.showGrid ? 
                      <div style={{cursor:'pointer',width:'32px', height:'32px', background:'#DA6C74',textAlign:'center', borderRadius:'6px',marginLeft:'20px',paddingTop:'2px'}} onClick={() => this.showView(true)}>{GridViewIcon()}</div> : 
                      <div style={{cursor:'pointer',width:'32px', height:'32px',textAlign:'center', borderRadius:'6px',marginLeft:'20px',paddingTop:'2px'}} onClick={() => this.showView(true)}>{GridViewIconInActive()}</div>
                    }
                  </IconsContainerV2>

                </ViewContainerV2>
              </div>
            </TopCard>
            
            <FilterIcon>
              <SearchFilter>
                <SearchIcon>
                  <img style={{ width: '100%' }} src="/public/images/searchIcon.png" alt="Search" />
                </SearchIcon>
                <StyledInputV2
                  type="text" value={this.state.search} placeholder={t("Search")}
                  onChange={(e) => this.onChange(e)}
                  onKeyDown={this.handleKeyDown}
                />
              </SearchFilter>
              <SearchFilterWrapper scroll={this.props.departmentDetails && this.props.departmentDetails.length > 15 ? 1 : 0}>
                <div className="wellness-interest">
                  {(this.state.selectUserDropDownId === 0 || this.state.selectUserDropDownId === 3 || this.state.selectUserDropDownId === 1 || this.state.selectUserDropDownId === 2) && wellnessInterests && wellnessInterests.length > 0 &&
                    <CustomDropDownWellness inputdisplay="block" inputpadding="0px 0px"
                      title={<div className="title">{t(this.getSelectedItemsText(selectedWellnessInterests, 'wellness'))}</div>}
                      id="wellness-sort"
                    >
                      <DropdownItem 
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.handleToggleAllWellness();
                        }}
                        style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #eee' }}
                      >
                        <input
                          className='check-input'
                          type="checkbox"
                          checked={wellnessInterests && selectedWellnessInterests.length === wellnessInterests.length}
                          onChange={() => {}}
                          style={{ marginRight: '16px', width:'20px', height:'20px' }}
                        />
                        <span>{t("Select All")}</span>
                      </DropdownItem>
                      {wellnessInterests.map((list, index) => (
                        <DropdownItem 
                          key={index} 
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.handleWellnessInterestSelection(list);
                          }}
                          style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}
                        >
                          <input
                            className='check-input'
                            type="checkbox"
                            checked={selectedWellnessInterests.some((item) => item.id === list.id)}
                            onChange={() => {}}
                            style={{ marginRight: '16px', width:'20px', height:'20px' }}
                          />
                          {t(list.name)}
                        </DropdownItem>
                      ))}
                    </CustomDropDownWellness>}
                </div>

                <div className="community-department">
                  {(this.state.selectUserDropDownId === 0 || this.state.selectUserDropDownId === 3 || this.state.selectUserDropDownId === 2 || this.state.selectUserDropDownId === 1) && this.props.departmentDetails && this.props.departmentDetails.length &&
                    <CustomDropDownV2 inputpadding="0px 0px"
                      type="button" 
                      title={<div className="title">{t(this.getSelectedItemsText(selectedDepartments, 'department'))}</div>}
                      id="department-sort"
                    >
                      <DropdownItem 
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.handleToggleAllDepartments();
                        }}
                        style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #eee' }}
                      >
                        <input
                          type="checkbox"
                          className='check-input'
                          checked={this.props.departmentDetails && selectedDepartments.length === this.props.departmentDetails.length}
                          onChange={() => {}}
                          style={{ marginRight: '16px', width:'20px', height:'20px' }}
                        />
                        <span>{t("Select All")}</span>
                      </DropdownItem>
                      {this.props.departmentDetails.map((list, index) => (
                        <DropdownItem 
                          key={index} 
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.handleDepartmentSelection(list);
                          }}
                          style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}
                        >
                          <input
                            type="checkbox"
                            className='check-input'
                            checked={selectedDepartments.some((item) => item.id === list.id)}
                            onChange={() => {}}
                            style={{ marginRight: '16px', width:'20px', height:'20px' }}
                          />
                          {t(list.department)}
                        </DropdownItem>
                      ))}
                    </CustomDropDownV2>}
                </div>

                <div className="location-dropdown">
                  {(this.state.selectUserDropDownId === 0 || this.state.selectUserDropDownId === 3 || this.state.selectUserDropDownId === 1 || this.state.selectUserDropDownId === 2) && this.props.locationDetails && this.props.locationDetails.length &&
                    <CustomDropDownV2 inputdisplay="block" inputpadding="0px 0px"
                      title={<div className="title">{t(this.getSelectedItemsText(selectedLocations, 'location'))}</div>}
                      id="location-sort"
                      style={{ "width": "290px", fontSize: "14px", borderRadius:'8px' }}
                    >
                      <DropdownItem 
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.handleToggleAllLocations();
                        }}
                        style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', borderBottom: '1px solid #eee' }}
                      >
                        <input
                          type="checkbox"
                          className='check-input'
                          checked={this.props.locationDetails && selectedLocations.length === this.props.locationDetails.length}
                          onChange={() => {}}
                          style={{ marginRight: '16px', width:'20px', height:'20px' }}
                        />
                        <span>{t("Select All")}</span>
                      </DropdownItem>
                      {this.props.locationDetails.map((list, index) => (
                        <DropdownItem 
                          key={index} 
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            this.handleLocationSelection(list);
                          }}
                          style={{ display: 'flex', alignItems: 'center', padding: '8px 16px' }}
                        >
                          <input
                            type="checkbox"
                            className='check-input'
                            checked={selectedLocations.some((item) => item.id === list.id)}
                            onChange={() => {}}
                            style={{ marginRight: '16px', width:'20px', height:'20px' }}
                          />
                          {t(list.state && list.city ? list.city + ", " + list.state : list.state === null && list.city ? list.city : list.state && list.city === null ? list.state : list.state || 'All Location')}
                        </DropdownItem>
                      ))}
                    </CustomDropDownV2>}
                </div>
              </SearchFilterWrapper>
            </FilterIcon>
          </HeaderWrapperV2>

          {friendRequests && friendRequests.length > 0 && searchAmigo && activeTab === 'connections' &&
            <RequestContainer background="white">
              <RequestText>
                {t("Connection Request")}
              </RequestText>
              <RequestCardWrapper style={{ flexWrap: 'wrap', height: 'auto', minHeight: '120px' }}>
                {friendRequests.map((request, index) =>
                  (<RequestCard key={index} style={{ minHeight: '120px', height: 'auto', marginBottom: '16px' }}>
                    <div className="profile">
                      <img onError={this.fallBack} src={`${ImageUrl}/${request.profile_image}`} alt={"Profile"} />
                    </div>
                    <div className="info">
                      <div className="name">{t(request.fullname)}</div>
                      <div className="wellness-icon">
                        {request.wellness_interest && request.wellness_interest.length > 0 && request.wellness_interest.map((wellness, idx) =>
                          (idx < 5 && <div key={idx} onMouseEnter={() => this.onEnterMouse(request.id, wellness.interest_id, wellness.interest_name)} onMouseLeave={() => this.onLeaveMouse()}>
                            <img src={`${ImageUrl}/${wellness.interest_icon}`} />
                          </div>
                          ))}
                      </div>
                    </div>
                    <div className="last-card">
                      <div 
                        className={`confirm ${this.state.processingRequests.has(request.id) ? 'disabled' : ''}`}
                        onClick={() => !this.state.processingRequests.has(request.id) && this.acceptOrRejectRequest(request.id, 'Accepted')}
                        style={{ opacity: this.state.processingRequests.has(request.id) ? 0.5 : 1, cursor: this.state.processingRequests.has(request.id) ? 'not-allowed' : 'pointer' }}
                      >
                        {t("Confirm")}
                      </div>
                      <div 
                        className={`cancel ${this.state.processingRequests.has(request.id) ? 'disabled' : ''}`}
                        onClick={() => !this.state.processingRequests.has(request.id) && this.acceptOrRejectRequest(request.id, 'Rejected')}
                        style={{ opacity: this.state.processingRequests.has(request.id) ? 0.5 : 1, cursor: this.state.processingRequests.has(request.id) ? 'not-allowed' : 'pointer' }}
                      >
                        {t("Delete")}
                      </div>
                    </div>

                  </RequestCard>))
                }
              </RequestCardWrapper>
            </RequestContainer>
          }

          

          <div style={{ "width": "100%", "display": "flex" }}>
            {this.state.loading ?
              <div style={{ width: '100%', display: 'flex', gap: '25px', flexWrap: 'wrap', marginTop: '25px' }}>
                <SkeletonLoder width={"291px"} height={"330px"} />
                <SkeletonLoder width={"291px"} height={"330px"} />
                <SkeletonLoder width={"291px"} height={"330px"} />
                <SkeletonLoder width={"291px"} height={"330px"} />
              </div> :
              <MainSectionV2>
                {displayData && displayData.length > 0 ? (
                  this.state.showGrid ?
                    <PeopleGridView
                      employeeList={displayData}
                      showEmployeeDetails={(id) => { if (!this.state.loading) this.setState({ selectedEmployee: id }); }}
                      selectedEmployee={selectedEmp}
                      searchAmigo={searchAmigo}
                      sendFriendRequestPost={this.fetchEmployeePost}
                      history={history}
                      show={activeButton}
                      activeTab={activeTab}
                      removeConnection={this.removeConnection}
                      showRemoveButton={showRemoveButton}
                      removeButtonId={removeButtonId}
                      showRemoveButtonHandler={this.showRemoveButtonHandler}
                      openRemoveBuddyPopup={this.openCloseRemoveBuddyPopup}
                      plp={{
                        "companyId": this.state.companyId,
                        "data": this.props.locationDetails,
                        "departmentData": this.props.departmentDetails,
                        "companyAuthDetails": companyDetails
                      }}
                    /> :
                    <PeopleListView
                      employeeList={displayData}
                      showEmployeeDetails={(id) => { if (!this.state.loading) this.setState({ selectedEmployee: id }); }}
                      selectedEmployee={selectedEmp}
                      searchAmigo={searchAmigo}
                      sendFriendRequestPost={this.fetchEmployeePost}
                      history={history}
                      show={activeButton}
                      activeTab={activeTab}
                      removeConnection={this.removeConnection}
                      showRemoveButton={showRemoveButton}
                      removeButtonId={removeButtonId}
                      showRemoveButtonHandler={this.showRemoveButtonHandler}
                      openRemoveBuddyPopup={this.openCloseRemoveBuddyPopup}
                      plp={{
                        "companyId": this.state.companyId,
                        "data": this.props.locationDetails,
                        "departmentData": this.props.departmentDetails,
                        "companyAuthDetails": companyDetails
                      }}
                    />
                ) : (
                  <div style={{ width: '100%', textAlign: 'center', padding: '50px' }}>
                    <p>{searchAmigo && activeTab === 'connections' ? t('No connections found') : activeTab === 'suggestions' ? t('No suggestions found') : t('No data available')}</p>
                  </div>
                )}

                {searchAmigo && activeTab === 'connections' && totalPages > 1 &&
                  <div className="pagination">
                    {this.state.pageNo > 1 &&
                      <UserButton width="30px" height="34px" Align={1} float={1} fontSize="14px"  capitalize={1} onClick={() => this.setState({ pageNo: this.state.pageNo - 1 }, () => this.fetchUserConnections())}>
                        <PriviousSolidIcon />
                      </UserButton>
                    }
                    {Array.from({ length: Math.min(totalPages, 6) }, (_, i) => {
                      const pageNum = i + 1;
                      return (
                        <UserButton
                          key={pageNum}
                          width="30px"
                          height="34px"
                          Align={1}
                          marginLeft="5px"
                          fontSize="14px"
                          bgColor={pageNum === this.state.pageNo ? "#DA6C74 " : "#f8f8f8"}
                          color={pageNum === this.state.pageNo ? "#fff" : "#DA6C74"}
                          style={pageNum === this.state.pageNo ? { color: '#fff !important' } : {}}
                          capitalize={1}
                          onClick={() => this.setState({ pageNo: pageNum }, () => this.fetchUserConnections())}
                        >
                          {pageNum}
                        </UserButton>
                      );
                    })}
                    {this.state.pageNo < totalPages &&
                      <UserButton width="30px" height="34px" Align={1} marginLeft="10px" fontSize="14px"  capitalize={1} onClick={() => this.setState({ pageNo: this.state.pageNo + 1 }, () => this.fetchUserConnections())}>
                        <NextSolidIcon />
                      </UserButton>
                    }
                  </div>
                }

                {searchAmigo && activeTab === 'suggestions' && totalPages > 1 &&
                  <div className="pagination">
                    {this.state.pageNo > 1 &&
                      <UserButton width="30px" height="34px" Align={1} float={1} fontSize="14px"  capitalize={1} onClick={() => this.setSuggestionsPagination(this.state.pageNo - 1)}>
                        {/* <img src="/public/images/CompanyDashBoardV2/NewIcon/leftcrossIcon.png" /> */}
                        <PriviousSolidIcon />
                      </UserButton>
                    }
                    {this.getSuggestionsPaginationCircle()}
                    {this.state.pageNo < totalPages &&
                      <UserButton width="30px" height="34px" Align={1} marginLeft="10px" fontSize="14px"  capitalize={1} onClick={() => this.setSuggestionsPagination(this.state.pageNo + 1)}>
                        {/* <img src="/public/images/CompanyDashBoardV2/NewIcon/rightcrossIcon.png" /> */}
                        <NextSolidIcon />
                      </UserButton>
                    }
                  </div>
                }

                {paginationCount > 25 && !searchAmigo &&
                  <div className="pagination">
                    {this.state.pageNo > 1 &&
                      <UserButton width="30px" height="34px" Align={1} float={1} fontSize="14px"  capitalize={1} onClick={() => this.setPagination(this.state.pageNo - 1)}>
                        <PriviousSolidIcon />
                      </UserButton>
                    }
                    {this.getPaginationCircle()}
                    {this.state.pageNo !== this.state.total &&
                      <UserButton width="30px" height="34px" Align={1} marginLeft="10px" fontSize="14px"  capitalize={1} onClick={() => this.setPagination(this.state.pageNo + 1)}>
                        <NextSolidIcon />
                      </UserButton>
                    }
                  </div>
                }
              </MainSectionV2>
            }
          </div>
        </Container>

        {!searchAmigo && <NewEmployeePopup companyId={this.state.companyId} postAddEmployee={this.props.postAddEmployee} show={showPopUp} showModalPopUp={this.addEmployeePopUp} companyAuthDetails={companyDetails} />}
        {!searchAmigo && showLocation && <Suspense fallback={<Waiting />}> <AddLocationPopup companyId={this.state.companyId} fetchEditLocationApi={this.props.fetchEditLocationApi} show={showLocation} data={this.props.locationDetails} showModalPopUp={this.updateLocationPopUp} companyAuthDetails={companyDetails} /></Suspense>}
        {!searchAmigo && showDepartment && <Suspense fallback={<Waiting />}> <AddDepartmentPopup companyId={this.state.companyId} fetchEditDepartmentApi={this.props.fetchEditDepartmentApi} show={showDepartment} data={this.props.departmentDetails} showModalPopUp={this.updateDepartmentPopUp} companyAuthDetails={companyDetails} /></Suspense>}
        {downloadCSV && !(_.isUndefined(csvData)) && !(_.isNull(csvData)) && <CSVMaker data={csvData} removeCSVData={removeCSVData} />}
        <ReactPDF showModal={showPDFModal} closeModal={this.closePopup} pdfBase64={pdfBase64} buttonText={buttonText} employee={selectedEmployeeDetail && selectedEmployeeDetail[0]} removePDF={this.removePDF} showCrossMarker={true} />
        {showRolesPopup && <Suspense fallback={<Waiting />}> <AddRolesPopup showModal={showRolesPopup} closeModal={this.onToggleRolesPopup} employee={selectedEmployeeDetail && selectedEmployeeDetail[0]} userRolesList={userRolesList} companyId={companyInfo.id} /></Suspense>}
        {showUserPopUp ? <Suspense fallback={<Waiting />}><EditUserDetailsPopup showUserModal={showUserPopUp} onClose={this.userModal} employee={selectedEmployeeDetail && selectedEmployeeDetail[0]} locationDetails={this.props.locationDetails} departmentDetails={this.props.departmentDetails} fetchEmployee={this.fetchEmployee} />  </Suspense> : null}
        {showRemoveBuddy && 
          <Suspense fallback={<Waiting />}>
            <RemoveBuddyPopup 
              showPopup={showRemoveBuddy} 
              onHide={this.closeRemoveBuddyPopup} 
              popupType={popupType} 
              friendId={removeBuddyId} 
              name={removeBuddyName}
              removeConnection={this.removeConnection}
            />
          </Suspense>
        }

      </Layout>
    );
  }
}

PeopleHome.defaultProps = {
  companyInfo: { id: 1, name: '' }
};

PeopleHome.propTypes = {
  fetchListOfEmployees: PropTypes.func.isRequired,
  employeeList: PropTypes.array,
  fetchSortedEmployees: PropTypes.func.isRequired,
  sortedList: PropTypes.array,
  history: PropTypes.object,
  employeeData: PropTypes.array,
  count: PropTypes.number,
  companyInfo: PropTypes.object,
  companies: PropTypes.array,
  fetchSearchPeople: PropTypes.func,
  postAddEmployee: PropTypes.func,
  fetchSetRemoveAPI: PropTypes.func,
  deleteEmployeeAPI: PropTypes.func,
  fetchEmployeeCount: PropTypes.func,
  setCompany: PropTypes.func,
  downloadCSV: PropTypes.bool,
  csvData: PropTypes.array,
  removeCSVData: PropTypes.func,
  locationDetails: PropTypes.array,
  departmentDetails: PropTypes.array,
  paginationCount: PropTypes.number,
  searchAmigo: PropTypes.bool,
  uploadBiometricForm: PropTypes.func,
  role: PropTypes.string,
  viewPhysicianFormAPI: PropTypes.func,
  biometricPdfFile: PropTypes.string,
  userPermissions: PropTypes.array,
  userRolesList: PropTypes.array,
  getUserRoles: PropTypes.func,
  getCompanyDetails: PropTypes.func,
  companyDetails: PropTypes.func,
  t: PropTypes.func,
  sendFriendRequest: PropTypes.func,
  fetchFriendRequests: PropTypes.func.isRequired,
  friendRequests: PropTypes.array,
  acceptOrRejectFriendRequest: PropTypes.func.isRequired,
  getWellnessInterests: PropTypes.func,
  wellnessInterests: PropTypes.array,
  showView: PropTypes.bool,
  fetchEditLocationApi: PropTypes.func,
  fetchEditDepartmentApi: PropTypes.func,
  userCompany: PropTypes.object,
  userProfile: PropTypes.object,
  getSentRequestList: PropTypes.func,
  sendRequestsData: PropTypes.array,
  removeUserFriend: PropTypes.func, 
  unFriendUser: PropTypes.func
};

const mapStateToProps = (state) => ({
  employeeList: state.peopleHome.employeeList,
  sortedList: state.peopleHome.sortedList,
  employeeData: state.peopleHome.employeeData,
  count: state.peopleHome.count,
  downloadCSV: state.peopleHome.csvMake,
  csvData: state.peopleHome.csvData,
  locationDetails: state.companyDashboard.companyPeopleLocation,
  departmentDetails: state.companyDashboard.companyPeopleDepartment,
  paginationCount: state.peopleHome.paginationCount,
  biometricPdfFile: state.profileData.biometricPdfFile,
  userPermissions: state.profileData.userPermissions,
  userRolesList: state.peopleHome.userRolesList,
  companyDetails: state.peopleHome.companyDetails,
  sentRequest: state.social.sentRequest,
  friendRequests: state.social.friendRequests,
  wellnessInterests: state.register.wellnessInterests,
  userCompany: state.profileData.userCompany,
  userProfile: state.profileData.userProfile,
  sendRequestsData: state.social.sendRequestsData
});

const mapDispatchToProps = (dispatch) => ({
  fetchListOfEmployees: () => dispatch(getListOfEmployees()),
  fetchSortedEmployees: (search, engagement, department, alphabetical) => dispatch(getSortedEmployees(search, engagement, department, alphabetical)),
  fetchSearchPeople: (data, cb) => dispatch(fetchSearchPeople(data, cb)),
  postAddEmployee: (data) => dispatch(PostAddEmployee(data)),
  fetchSetRemoveAPI: (obj) => dispatch(FetchSetRemoveAPI(obj)),
  deleteEmployeeAPI: (obj) => dispatch(DeleteEmployeeAPI(obj)),
  fetchEmployeeCount: (obj, bool) => dispatch(FetchEmployeeCount(obj, bool)),
  removeCSVData: () => dispatch(RemoveCSVData()),
  uploadBiometricForm: (obj, cb, userId, fetchEmployee) => dispatch(uploadBiometricForm(obj, cb, userId, fetchEmployee)),
  viewPhysicianFormAPI: (uid, cb) => dispatch(viewPhysicianFormAPI(uid, cb)),
  getUserRoles: (uid) => dispatch(getUserRoles(uid)),
  getCompanyDetails: (companyId) => dispatch(getCompanyDetails(companyId)),
  sendFriendRequest: (data, obj) => dispatch(sendFriendRequest(data, obj)),
  fetchFriendRequests: () => dispatch(getFriendRequests()),
  acceptOrRejectFriendRequest: (acceptData) => dispatch(acceptOrRejectFriendRequest(acceptData)),
  getWellnessInterests: () => dispatch(getWellnessInterests()),
  fetchEditLocationApi: (data, deleteloc) => dispatch(editLocationApi(data, deleteloc)),
  fetchEditDepartmentApi: (data, deletedept) => dispatch(editDepartmentApi(data, deletedept)),
  getSentRequestList: () => dispatch(getSentRequestList()),
  unFriendUser: (userId, reload) => dispatch(unFriendUser(userId, reload))


});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PeopleHome));
